import '../../verification/style.css';

const ApiError = ()=>{
    return (
        <div className='container'>
            <div className='response-overlay'>
            <div className='response-box'>
            <div className='error-response'>
    <p>Something Went Wrong!</p>
    <div className='description'>
    We’ve encountered an issue, but we’re here to help! 
    <br></br><br/>
    Please try again or check back later by clicking on the 
    CLEAR registration link in the initial email request from T-Mobile.
    </div>
    </div>
            </div>
            </div>
    </div>
    )
};

export default ApiError;